import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useSearchParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import DriverLayout from "@/pages/driver/DriverLayout";
import DriverHome from "@/pages/driver/DriverHome";
import NewClosing from "@/pages/driver/NewClosing";
import History from "@/pages/driver/History";
import MonthlySummary from "@/pages/driver/MonthlySummary";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Drivers from "@/pages/admin/Drivers";
import Cadastros from "@/pages/admin/Cadastros";
import Closings from "@/pages/admin/Closings";
import ReviewClosing from "@/pages/admin/ReviewClosing";
import MonthlyDashboard from "@/pages/admin/MonthlyDashboard";
import MonthlyClosing from "@/pages/admin/MonthlyClosing";
import Ranking from "@/pages/admin/Ranking";
import Reports from "@/pages/admin/Reports";
import Conference from "@/pages/admin/Conference";
import Occurrences from "@/pages/Occurrences";
function ClosingPage() {
  const [params] = useSearchParams();
  return <NewClosing key={params.toString()} />;
}
import "@/App.css";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/trocar-senha" replace />;
  return <Navigate to={user.role === "motorista" ? "/motorista" : "/admin"} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/trocar-senha"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />

          <Route
            path="/motorista"
            element={
              <ProtectedRoute role="motorista">
                <DriverLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DriverHome />} />
            <Route path="fechamento" element={<ClosingPage />} />
            <Route path="ocorrencias" element={<Occurrences />} />
            <Route path="historico" element={<History />} />
            <Route path="mensal" element={<MonthlySummary />} />
          </Route>

          <Route
            path="/admin"
            element={
              <ProtectedRoute roles={["admin", "supervisor"]}>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="motoristas" element={<ProtectedRoute role="admin"><Drivers /></ProtectedRoute>} />
            <Route path="cadastros" element={<ProtectedRoute role="admin"><Cadastros /></ProtectedRoute>} />
            <Route path="fechamentos" element={<Closings />} />
            <Route path="fechamentos/:id" element={<ReviewClosing />} />
            <Route path="mensal" element={<ProtectedRoute role="admin"><MonthlyDashboard /></ProtectedRoute>} />
            <Route path="fechamento-mensal" element={<ProtectedRoute role="admin"><MonthlyClosing /></ProtectedRoute>} />
            <Route path="conferencia" element={<Conference />} />
            <Route path="pendencias" element={<Occurrences />} />
            <Route path="adicionar-fechamento" element={<ClosingPage />} />
            <Route path="ranking" element={<Ranking />} />
            <Route path="relatorios" element={<Reports />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
